import styled from '@emotion/styled'

export const Wrapper = styled.div`
  width: 16px;
  height: 16px;
  padding-top: 4px;
  padding-left: 6px;
`
